type Paginator = <T>(data: T[], currentPage: number, size: number) => T[];

export const useClientPaginator: Paginator = (data, currentPage, size) => {
  const indexOfLastData = currentPage * size;
  const indexOfFirstData = indexOfLastData - size;

  return data.length > size
    ? data.slice(indexOfFirstData, indexOfLastData)
    : data;
};
